'use client';

import React, {createContext, useContext} from 'react';

import {PropsProviderType} from './props-provider-types';

const PropsContext = createContext<PropsProviderType>({
  domain: '',
  sessionType: '',
  phdAuthProxyBaseFullURL: '',
  authProxyBaseURL: '',
  userManagementMpPathToFile: '',
  ohidSessionCheckInterval: 0,
  ohidRefreshTokenBeforeExpireIn: 0,
  inactiveTime: 0,
  countdownTime: 0,
  phdAuthProxyBaseURL: '',
  formularyMpDomainUrl: '',
  remittanceMPPathToFile: '',
  isLocalEnv: false,
  aemDomainUrl: '',
  docMgmtMcpHost: '',
  buildEnv: '',
  docClasses: '',
  nonUserId: '',
  uPayeeId: '',
  correlationId: '',
  providerInstanceId: '',
  consumerInstanceId: '',
  remittanceTenantName: '',
  userManagementTenantName: ''
});

export function PropsProvider({children, propsValues}: {children: React.ReactNode; propsValues: PropsProviderType}) {
  return <PropsContext.Provider value={propsValues}>{children}</PropsContext.Provider>;
}

export const usePropsProvider = () => useContext(PropsContext);
